import {
    createImageHeader,
    ImageHeader,
} from '@vfde-brix/ws10/image-header';
import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { selectHasDevice } from 'Container/App/slice';
import { startAppListening } from 'Container/App/listener';
import { IMAGE_HEADER_CONTAINER } from 'Container/App/constants';

const mountImageHeader = (): ImageHeader | null => {
    const imageHeader = createComponentById(createImageHeader, IMAGE_HEADER_CONTAINER, NO_PATTERN_BUSINESS_LOGIC);

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectHasDevice(currentState) !== selectHasDevice(previousState),
        effect: (_action, api) => {
            const hasDevice = selectHasDevice(api.getState());

            imageHeader?.toggleContainer(hasDevice);
        },
    });

    return imageHeader;
};

export default mountImageHeader;
